import React from "react";

import { MissingLabelReportManuallyButton } from "../MissingLabelReportManuallyButton";
import { UnexpectedSkuModal } from "../../components/modals";

export const MissingLabelUnexpectedSkuModal = () => (
  <UnexpectedSkuModal ReportManuallyButton={MissingLabelReportManuallyButton} />
);
